import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GLOBAL } from '../../app/global';

@Injectable({
  providedIn: 'root'
})
export class TipoIdentificacionService {

  urlTipoDocumento: string;

  /**
   * @author Frank Edward Daza González
   * @version 2018-10-05
   * @param httpClient
   */
  constructor(private httpClient: HttpClient) {
    this.urlTipoDocumento = GLOBAL.URL_BASE + 'sicaTipoIdentificacion';
  }

   /**
    * Retorna un JSON de tipos de documentos.
    * 
    * @author Frank Edward Daza González
    * @version 2018-10-05
    */
   getDataSicaTipoIdentificacion(): Observable<any> {
     return this.httpClient.get(this.urlTipoDocumento + '/getDataSicaTipoIdentificacion');
   }

}
